import Layout from '../../config/Layout';
import Colors from '../../config/Colors';

const styles = {
    modalDisp: {
        content: {
            minWidth: 160,
            borderRadius: 10,
            top: -5,
            left: 70,
            right: 'auto',
            bottom: 'auto',
            paddingBottom: 15
        },
        overlay: {
            backgroundColor: Colors.transparent
        }
    },
    modalDispMobile: {
        content: {
            minWidth: 300,
            borderRadius: 10,
            paddingBottom: 15,
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)'
        },
        overlay: {
            backgroundColor: Colors.darkTransparent
        }
    },
    modalContent: {
        minWidth: 300,
        alignItems: 'stretch'
    },
    titleLine: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    dispContainer: {
        alignItems: 'center',
        flexDirection: 'row'
    },
    dispText: {
        paddingLeft: Layout.gutterMedium
    },
    pageTitle: {
        paddingBottom: Layout.gutterMin,
        fontSize: 22
    },
    modalHeader: {
        flex: 1,
        display: 'flex',
        flexDirection: 'row',
        paddingRight: 5
    }
};

export default styles;
